import React, { FC, ReactNode } from 'react';

interface LayoutProps {
	children: ReactNode;
}

export const Layout: FC<LayoutProps> = ({ children }) => {
	return (
		<div className="bg-gray-100 flex grow sm:justify-center sm:items-center">
			<div className="relative bg-white sm:my-3 w-5/6 sm:max-w-xl flex flex-col grow sm:grow-0 sm:shadow-[0_0_6px_rgba(0,0,0,0.1)] sm:rounded-2xl">
				{children}
			</div>
		</div>
	);
};
